import {Component, OnInit} from '@angular/core';

import { Api } from '../../../services/api.service';
import { BreadcrumbItem } from '../../../entities/index';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-ota-detail',
  templateUrl: './ota-detail.html'
})

export class OtaDetailComponent implements OnInit {
  pageTitle = 'Ota';
  form: OtaForm = new OtaForm();
  imeiList: string[];
  stats: OtaStats = new OtaStats();
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('OTA', 'wifi')
  ];

  constructor(protected http: Api) {
  }

  @Log('blue')
  send() {
    this.http
      .post(`ota`, {total: this.form.total})
      .subscribe(res => {
        console.log(res);
        this.imeiList = res;
      });
  }

  @Log()
  ngOnInit() {
    this.get();
  }

  @Log('green')
  get() {
    this.http
      .get(`ota`)
      .subscribe(res => {
        this.stats = res;
      });
  }
}

class OtaForm {
  total: string;
}

class OtaStats {
  migrated: number;
  park: number;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/ota/ota-detail.component.ts